import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "squareup.connect.v2.common";
/**
* --
* @desc Indicates the associated currency for an amount of money. Values correspond
* to [ISO 4217](https://wikipedia.org/wiki/ISO_4217).
* --
*/
export let Currency = /* @__PURE__ */ function(Currency) {
	/**
	* UNKNOWN_CURRENCY - --
	* @desc Unknown currency
	* --
	*/
	Currency[Currency["UNKNOWN_CURRENCY"] = 0] = "UNKNOWN_CURRENCY";
	/**
	* AED - --
	* @desc United Arab Emirates dirham
	* --
	*/
	Currency[Currency["AED"] = 784] = "AED";
	/**
	* AFN - --
	* @desc Afghan afghani
	* --
	*/
	Currency[Currency["AFN"] = 971] = "AFN";
	/**
	* ALL - --
	* @desc Albanian lek
	* --
	*/
	Currency[Currency["ALL"] = 8] = "ALL";
	/**
	* AMD - --
	* @desc Armenian dram
	* --
	*/
	Currency[Currency["AMD"] = 51] = "AMD";
	/**
	* ANG - --
	* @desc Netherlands Antillean guilder
	* --
	*/
	Currency[Currency["ANG"] = 532] = "ANG";
	/**
	* AOA - --
	* @desc Angolan kwanza
	* --
	*/
	Currency[Currency["AOA"] = 973] = "AOA";
	/**
	* ARS - --
	* @desc Argentine peso
	* --
	*/
	Currency[Currency["ARS"] = 32] = "ARS";
	/**
	* AUD - --
	* @desc Australian dollar
	* --
	*/
	Currency[Currency["AUD"] = 36] = "AUD";
	/**
	* AWG - --
	* @desc Aruban florin
	* --
	*/
	Currency[Currency["AWG"] = 533] = "AWG";
	/**
	* AZN - --
	* @desc Azerbaijani manat
	* --
	*/
	Currency[Currency["AZN"] = 944] = "AZN";
	/**
	* BAM - --
	* @desc Bosnia and Herzegovina convertible mark
	* --
	*/
	Currency[Currency["BAM"] = 977] = "BAM";
	/**
	* BBD - --
	* @desc Barbados dollar
	* --
	*/
	Currency[Currency["BBD"] = 52] = "BBD";
	/**
	* BDT - --
	* @desc Bangladeshi taka
	* --
	*/
	Currency[Currency["BDT"] = 50] = "BDT";
	/**
	* BGN - --
	* @desc Bulgarian lev
	* --
	*/
	Currency[Currency["BGN"] = 975] = "BGN";
	/**
	* BHD - --
	* @desc Bahraini dinar
	* --
	*/
	Currency[Currency["BHD"] = 48] = "BHD";
	/**
	* BIF - --
	* @desc Burundian franc
	* --
	*/
	Currency[Currency["BIF"] = 108] = "BIF";
	/**
	* BMD - --
	* @desc Bermudian dollar
	* --
	*/
	Currency[Currency["BMD"] = 60] = "BMD";
	/**
	* BND - --
	* @desc Brunei dollar
	* --
	*/
	Currency[Currency["BND"] = 96] = "BND";
	/**
	* BOB - --
	* @desc Boliviano
	* --
	*/
	Currency[Currency["BOB"] = 68] = "BOB";
	/**
	* BOV - --
	* @desc Bolivian Mvdol
	* --
	*/
	Currency[Currency["BOV"] = 984] = "BOV";
	/**
	* BRL - --
	* @desc Brazilian real
	* --
	*/
	Currency[Currency["BRL"] = 986] = "BRL";
	/**
	* BSD - --
	* @desc Bahamian dollar
	* --
	*/
	Currency[Currency["BSD"] = 44] = "BSD";
	/**
	* BTN - --
	* @desc Bhutanese ngultrum
	* --
	*/
	Currency[Currency["BTN"] = 64] = "BTN";
	/**
	* BWP - --
	* @desc Botswana pula
	* --
	*/
	Currency[Currency["BWP"] = 72] = "BWP";
	/**
	* BYR - --
	* @desc Belarusian ruble
	* --
	*/
	Currency[Currency["BYR"] = 974] = "BYR";
	/**
	* BZD - --
	* @desc Belize dollar
	* --
	*/
	Currency[Currency["BZD"] = 84] = "BZD";
	/**
	* CAD - --
	* @desc Canadian dollar
	* --
	*/
	Currency[Currency["CAD"] = 124] = "CAD";
	/**
	* CDF - --
	* @desc Congolese franc
	* --
	*/
	Currency[Currency["CDF"] = 976] = "CDF";
	/**
	* CHE - --
	* @desc WIR Euro
	* --
	*/
	Currency[Currency["CHE"] = 947] = "CHE";
	/**
	* CHF - --
	* @desc Swiss franc
	* --
	*/
	Currency[Currency["CHF"] = 756] = "CHF";
	/**
	* CHW - --
	* @desc WIR Franc
	* --
	*/
	Currency[Currency["CHW"] = 948] = "CHW";
	/**
	* CLF - --
	* @desc Unidad de Fomento
	* --
	*/
	Currency[Currency["CLF"] = 990] = "CLF";
	/**
	* CLP - --
	* @desc Chilean peso
	* --
	*/
	Currency[Currency["CLP"] = 152] = "CLP";
	/**
	* CNY - --
	* @desc Chinese yuan
	* --
	*/
	Currency[Currency["CNY"] = 156] = "CNY";
	/**
	* COP - --
	* @desc Colombian peso
	* --
	*/
	Currency[Currency["COP"] = 170] = "COP";
	/**
	* COU - --
	* @desc Unidad de Valor Real
	* --
	*/
	Currency[Currency["COU"] = 970] = "COU";
	/**
	* CRC - --
	* @desc Costa Rican colon
	* --
	*/
	Currency[Currency["CRC"] = 188] = "CRC";
	/**
	* CUC - --
	* @desc Cuban convertible peso
	* --
	*/
	Currency[Currency["CUC"] = 931] = "CUC";
	/**
	* CUP - --
	* @desc Cuban peso
	* --
	*/
	Currency[Currency["CUP"] = 192] = "CUP";
	/**
	* CVE - --
	* @desc Cape Verdean escudo
	* --
	*/
	Currency[Currency["CVE"] = 132] = "CVE";
	/**
	* CZK - --
	* @desc Czech koruna
	* --
	*/
	Currency[Currency["CZK"] = 203] = "CZK";
	/**
	* DJF - --
	* @desc Djiboutian franc
	* --
	*/
	Currency[Currency["DJF"] = 262] = "DJF";
	/**
	* DKK - --
	* @desc Danish krone
	* --
	*/
	Currency[Currency["DKK"] = 208] = "DKK";
	/**
	* DOP - --
	* @desc Dominican peso
	* --
	*/
	Currency[Currency["DOP"] = 214] = "DOP";
	/**
	* DZD - --
	* @desc Algerian dinar
	* --
	*/
	Currency[Currency["DZD"] = 12] = "DZD";
	/**
	* EGP - --
	* @desc Egyptian pound
	* --
	*/
	Currency[Currency["EGP"] = 818] = "EGP";
	/**
	* ERN - --
	* @desc Eritrean nakfa
	* --
	*/
	Currency[Currency["ERN"] = 232] = "ERN";
	/**
	* ETB - --
	* @desc Ethiopian birr
	* --
	*/
	Currency[Currency["ETB"] = 230] = "ETB";
	/**
	* EUR - --
	* @desc Euro
	* --
	*/
	Currency[Currency["EUR"] = 978] = "EUR";
	/**
	* FJD - --
	* @desc Fiji dollar
	* --
	*/
	Currency[Currency["FJD"] = 242] = "FJD";
	/**
	* FKP - --
	* @desc Falkland Islands pound
	* --
	*/
	Currency[Currency["FKP"] = 238] = "FKP";
	/**
	* GBP - --
	* @desc Pound sterling
	* --
	*/
	Currency[Currency["GBP"] = 826] = "GBP";
	/**
	* GEL - --
	* @desc Georgian lari
	* --
	*/
	Currency[Currency["GEL"] = 981] = "GEL";
	/**
	* GHS - --
	* @desc Ghanaian cedi
	* --
	*/
	Currency[Currency["GHS"] = 936] = "GHS";
	/**
	* GIP - --
	* @desc Gibraltar pound
	* --
	*/
	Currency[Currency["GIP"] = 292] = "GIP";
	/**
	* GMD - --
	* @desc Gambian dalasi
	* --
	*/
	Currency[Currency["GMD"] = 270] = "GMD";
	/**
	* GNF - --
	* @desc Guinean franc
	* --
	*/
	Currency[Currency["GNF"] = 324] = "GNF";
	/**
	* GTQ - --
	* @desc Guatemalan quetzal
	* --
	*/
	Currency[Currency["GTQ"] = 320] = "GTQ";
	/**
	* GYD - --
	* @desc Guyanese dollar
	* --
	*/
	Currency[Currency["GYD"] = 328] = "GYD";
	/**
	* HKD - --
	* @desc Hong Kong dollar
	* --
	*/
	Currency[Currency["HKD"] = 344] = "HKD";
	/**
	* HNL - --
	* @desc Honduran lempira
	* --
	*/
	Currency[Currency["HNL"] = 340] = "HNL";
	/**
	* HRK - --
	* @desc Croatian kuna
	* --
	*/
	Currency[Currency["HRK"] = 191] = "HRK";
	/**
	* HTG - --
	* @desc Haitian gourde
	* --
	*/
	Currency[Currency["HTG"] = 332] = "HTG";
	/**
	* HUF - --
	* @desc Hungarian forint
	* --
	*/
	Currency[Currency["HUF"] = 348] = "HUF";
	/**
	* IDR - --
	* @desc Indonesian rupiah
	* --
	*/
	Currency[Currency["IDR"] = 360] = "IDR";
	/**
	* ILS - --
	* @desc Israeli new shekel
	* --
	*/
	Currency[Currency["ILS"] = 376] = "ILS";
	/**
	* INR - --
	* @desc Indian rupee
	* --
	*/
	Currency[Currency["INR"] = 356] = "INR";
	/**
	* IQD - --
	* @desc Iraqi dinar
	* --
	*/
	Currency[Currency["IQD"] = 368] = "IQD";
	/**
	* IRR - --
	* @desc Iranian rial
	* --
	*/
	Currency[Currency["IRR"] = 364] = "IRR";
	/**
	* ISK - --
	* @desc Icelandic króna
	* --
	*/
	Currency[Currency["ISK"] = 352] = "ISK";
	/**
	* JMD - --
	* @desc Jamaican dollar
	* --
	*/
	Currency[Currency["JMD"] = 388] = "JMD";
	/**
	* JOD - --
	* @desc Jordanian dinar
	* --
	*/
	Currency[Currency["JOD"] = 400] = "JOD";
	/**
	* JPY - --
	* @desc Japanese yen
	* --
	*/
	Currency[Currency["JPY"] = 392] = "JPY";
	/**
	* KES - --
	* @desc Kenyan shilling
	* --
	*/
	Currency[Currency["KES"] = 404] = "KES";
	/**
	* KGS - --
	* @desc Kyrgyzstani som
	* --
	*/
	Currency[Currency["KGS"] = 417] = "KGS";
	/**
	* KHR - --
	* @desc Cambodian riel
	* --
	*/
	Currency[Currency["KHR"] = 116] = "KHR";
	/**
	* KMF - --
	* @desc Comoro franc
	* --
	*/
	Currency[Currency["KMF"] = 174] = "KMF";
	/**
	* KPW - --
	* @desc North Korean won
	* --
	*/
	Currency[Currency["KPW"] = 408] = "KPW";
	/**
	* KRW - --
	* @desc South Korean won
	* --
	*/
	Currency[Currency["KRW"] = 410] = "KRW";
	/**
	* KWD - --
	* @desc Kuwaiti dinar
	* --
	*/
	Currency[Currency["KWD"] = 414] = "KWD";
	/**
	* KYD - --
	* @desc Cayman Islands dollar
	* --
	*/
	Currency[Currency["KYD"] = 136] = "KYD";
	/**
	* KZT - --
	* @desc Kazakhstani tenge
	* --
	*/
	Currency[Currency["KZT"] = 398] = "KZT";
	/**
	* LAK - --
	* @desc Lao kip
	* --
	*/
	Currency[Currency["LAK"] = 418] = "LAK";
	/**
	* LBP - --
	* @desc Lebanese pound
	* --
	*/
	Currency[Currency["LBP"] = 422] = "LBP";
	/**
	* LKR - --
	* @desc Sri Lankan rupee
	* --
	*/
	Currency[Currency["LKR"] = 144] = "LKR";
	/**
	* LRD - --
	* @desc Liberian dollar
	* --
	*/
	Currency[Currency["LRD"] = 430] = "LRD";
	/**
	* LSL - --
	* @desc Lesotho loti
	* --
	*/
	Currency[Currency["LSL"] = 426] = "LSL";
	/**
	* LTL - --
	* @desc Lithuanian litas
	* --
	*/
	Currency[Currency["LTL"] = 440] = "LTL";
	/**
	* LVL - --
	* @desc Latvian lats
	* --
	*/
	Currency[Currency["LVL"] = 428] = "LVL";
	/**
	* LYD - --
	* @desc Libyan dinar
	* --
	*/
	Currency[Currency["LYD"] = 434] = "LYD";
	/**
	* MAD - --
	* @desc Moroccan dirham
	* --
	*/
	Currency[Currency["MAD"] = 504] = "MAD";
	/**
	* MDL - --
	* @desc Moldovan leu
	* --
	*/
	Currency[Currency["MDL"] = 498] = "MDL";
	/**
	* MGA - --
	* @desc Malagasy ariary
	* --
	*/
	Currency[Currency["MGA"] = 969] = "MGA";
	/**
	* MKD - --
	* @desc Macedonian denar
	* --
	*/
	Currency[Currency["MKD"] = 807] = "MKD";
	/**
	* MMK - --
	* @desc Myanmar kyat
	* --
	*/
	Currency[Currency["MMK"] = 104] = "MMK";
	/**
	* MNT - --
	* @desc Mongolian tögrög
	* --
	*/
	Currency[Currency["MNT"] = 496] = "MNT";
	/**
	* MOP - --
	* @desc Macanese pataca
	* --
	*/
	Currency[Currency["MOP"] = 446] = "MOP";
	/**
	* MRO - --
	* @desc Mauritanian ouguiya
	* --
	*/
	Currency[Currency["MRO"] = 478] = "MRO";
	/**
	* MUR - --
	* @desc Mauritian rupee
	* --
	*/
	Currency[Currency["MUR"] = 480] = "MUR";
	/**
	* MVR - --
	* @desc Maldivian rufiyaa
	* --
	*/
	Currency[Currency["MVR"] = 462] = "MVR";
	/**
	* MWK - --
	* @desc Malawian kwacha
	* --
	*/
	Currency[Currency["MWK"] = 454] = "MWK";
	/**
	* MXN - --
	* @desc Mexican peso
	* --
	*/
	Currency[Currency["MXN"] = 484] = "MXN";
	/**
	* MXV - --
	* @desc Mexican Unidad de Inversion
	* --
	*/
	Currency[Currency["MXV"] = 979] = "MXV";
	/**
	* MYR - --
	* @desc Malaysian ringgit
	* --
	*/
	Currency[Currency["MYR"] = 458] = "MYR";
	/**
	* MZN - --
	* @desc Mozambican metical
	* --
	*/
	Currency[Currency["MZN"] = 943] = "MZN";
	/**
	* NAD - --
	* @desc Namibian dollar
	* --
	*/
	Currency[Currency["NAD"] = 516] = "NAD";
	/**
	* NGN - --
	* @desc Nigerian naira
	* --
	*/
	Currency[Currency["NGN"] = 566] = "NGN";
	/**
	* NIO - --
	* @desc Nicaraguan córdoba
	* --
	*/
	Currency[Currency["NIO"] = 558] = "NIO";
	/**
	* NOK - --
	* @desc Norwegian krone
	* --
	*/
	Currency[Currency["NOK"] = 578] = "NOK";
	/**
	* NPR - --
	* @desc Nepalese rupee
	* --
	*/
	Currency[Currency["NPR"] = 524] = "NPR";
	/**
	* NZD - --
	* @desc New Zealand dollar
	* --
	*/
	Currency[Currency["NZD"] = 554] = "NZD";
	/**
	* OMR - --
	* @desc Omani rial
	* --
	*/
	Currency[Currency["OMR"] = 512] = "OMR";
	/**
	* PAB - --
	* @desc Panamanian balboa
	* --
	*/
	Currency[Currency["PAB"] = 590] = "PAB";
	/**
	* PEN - --
	* @desc Peruvian sol
	* --
	*/
	Currency[Currency["PEN"] = 604] = "PEN";
	/**
	* PGK - --
	* @desc Papua New Guinean kina
	* --
	*/
	Currency[Currency["PGK"] = 598] = "PGK";
	/**
	* PHP - --
	* @desc Philippine peso
	* --
	*/
	Currency[Currency["PHP"] = 608] = "PHP";
	/**
	* PKR - --
	* @desc Pakistani rupee
	* --
	*/
	Currency[Currency["PKR"] = 586] = "PKR";
	/**
	* PLN - --
	* @desc Polish złoty
	* --
	*/
	Currency[Currency["PLN"] = 985] = "PLN";
	/**
	* PYG - --
	* @desc Paraguayan guaraní
	* --
	*/
	Currency[Currency["PYG"] = 600] = "PYG";
	/**
	* QAR - --
	* @desc Qatari riyal
	* --
	*/
	Currency[Currency["QAR"] = 634] = "QAR";
	/**
	* RON - --
	* @desc Romanian leu
	* --
	*/
	Currency[Currency["RON"] = 946] = "RON";
	/**
	* RSD - --
	* @desc Serbian dinar
	* --
	*/
	Currency[Currency["RSD"] = 941] = "RSD";
	/**
	* RUB - --
	* @desc Russian ruble
	* --
	*/
	Currency[Currency["RUB"] = 643] = "RUB";
	/**
	* RWF - --
	* @desc Rwandan franc
	* --
	*/
	Currency[Currency["RWF"] = 646] = "RWF";
	/**
	* SAR - --
	* @desc Saudi riyal
	* --
	*/
	Currency[Currency["SAR"] = 682] = "SAR";
	/**
	* SBD - --
	* @desc Solomon Islands dollar
	* --
	*/
	Currency[Currency["SBD"] = 90] = "SBD";
	/**
	* SCR - --
	* @desc Seychelles rupee
	* --
	*/
	Currency[Currency["SCR"] = 690] = "SCR";
	/**
	* SDG - --
	* @desc Sudanese pound
	* --
	*/
	Currency[Currency["SDG"] = 938] = "SDG";
	/**
	* SEK - --
	* @desc Swedish krona
	* --
	*/
	Currency[Currency["SEK"] = 752] = "SEK";
	/**
	* SGD - --
	* @desc Singapore dollar
	* --
	*/
	Currency[Currency["SGD"] = 702] = "SGD";
	/**
	* SHP - --
	* @desc Saint Helena pound
	* --
	*/
	Currency[Currency["SHP"] = 654] = "SHP";
	/**
	* SLL - --
	* @desc Sierra Leonean first leone
	* --
	*/
	Currency[Currency["SLL"] = 694] = "SLL";
	/**
	* SLE - --
	* @desc Sierra Leonean second leone
	* --
	*/
	Currency[Currency["SLE"] = 925] = "SLE";
	/**
	* SOS - --
	* @desc Somali shilling
	* --
	*/
	Currency[Currency["SOS"] = 706] = "SOS";
	/**
	* SRD - --
	* @desc Surinamese dollar
	* --
	*/
	Currency[Currency["SRD"] = 968] = "SRD";
	/**
	* SSP - --
	* @desc South Sudanese pound
	* --
	*/
	Currency[Currency["SSP"] = 728] = "SSP";
	/**
	* STD - --
	* @desc São Tomé and Príncipe dobra
	* --
	*/
	Currency[Currency["STD"] = 678] = "STD";
	/**
	* SVC - --
	* @desc Salvadoran colón
	* --
	*/
	Currency[Currency["SVC"] = 222] = "SVC";
	/**
	* SYP - --
	* @desc Syrian pound
	* --
	*/
	Currency[Currency["SYP"] = 760] = "SYP";
	/**
	* SZL - --
	* @desc Swazi lilangeni
	* --
	*/
	Currency[Currency["SZL"] = 748] = "SZL";
	/**
	* THB - --
	* @desc Thai baht
	* --
	*/
	Currency[Currency["THB"] = 764] = "THB";
	/**
	* TJS - --
	* @desc Tajikstani somoni
	* --
	*/
	Currency[Currency["TJS"] = 972] = "TJS";
	/**
	* TMT - --
	* @desc Turkmenistan manat
	* --
	*/
	Currency[Currency["TMT"] = 934] = "TMT";
	/**
	* TND - --
	* @desc Tunisian dinar
	* --
	*/
	Currency[Currency["TND"] = 788] = "TND";
	/**
	* TOP - --
	* @desc Tongan pa'anga
	* --
	*/
	Currency[Currency["TOP"] = 776] = "TOP";
	/**
	* TRY - --
	* @desc Turkish lira
	* --
	*/
	Currency[Currency["TRY"] = 949] = "TRY";
	/**
	* TTD - --
	* @desc Trinidad and Tobago dollar
	* --
	*/
	Currency[Currency["TTD"] = 780] = "TTD";
	/**
	* TWD - --
	* @desc New Taiwan dollar
	* --
	*/
	Currency[Currency["TWD"] = 901] = "TWD";
	/**
	* TZS - --
	* @desc Tanzanian shilling
	* --
	*/
	Currency[Currency["TZS"] = 834] = "TZS";
	/**
	* UAH - --
	* @desc Ukrainian hryvnia
	* --
	*/
	Currency[Currency["UAH"] = 980] = "UAH";
	/**
	* UGX - --
	* @desc Ugandan shilling
	* --
	*/
	Currency[Currency["UGX"] = 800] = "UGX";
	/**
	* USD - --
	* @desc United States dollar
	* --
	*/
	Currency[Currency["USD"] = 840] = "USD";
	/**
	* USN - --
	* @desc United States dollar (next day)
	* --
	*/
	Currency[Currency["USN"] = 997] = "USN";
	/**
	* USS - --
	* @desc United States dollar (same day)
	* --
	*/
	Currency[Currency["USS"] = 998] = "USS";
	/**
	* UYI - --
	* @desc Uruguay Peso en Unidedades Indexadas
	* --
	*/
	Currency[Currency["UYI"] = 940] = "UYI";
	/**
	* UYU - --
	* @desc Uruguyan peso
	* --
	*/
	Currency[Currency["UYU"] = 858] = "UYU";
	/**
	* UZS - --
	* @desc Uzbekistan som
	* --
	*/
	Currency[Currency["UZS"] = 860] = "UZS";
	/**
	* VEF - --
	* @desc Venezuelan bolívar soberano
	* --
	*/
	Currency[Currency["VEF"] = 937] = "VEF";
	/**
	* VND - --
	* @desc Vietnamese đồng
	* --
	*/
	Currency[Currency["VND"] = 704] = "VND";
	/**
	* VUV - --
	* @desc Vanuatu vatu
	* --
	*/
	Currency[Currency["VUV"] = 548] = "VUV";
	/**
	* WST - --
	* @desc Samoan tala
	* --
	*/
	Currency[Currency["WST"] = 882] = "WST";
	/**
	* XAF - --
	* @desc CFA franc BEAC
	* --
	*/
	Currency[Currency["XAF"] = 950] = "XAF";
	/**
	* XAG - --
	* @desc Silver
	* --
	*/
	Currency[Currency["XAG"] = 961] = "XAG";
	/**
	* XAU - --
	* @desc Gold
	* --
	*/
	Currency[Currency["XAU"] = 959] = "XAU";
	/**
	* XBA - --
	* @desc European Composite Unit
	* --
	*/
	Currency[Currency["XBA"] = 955] = "XBA";
	/**
	* XBB - --
	* @desc European Monetary Unit
	* --
	*/
	Currency[Currency["XBB"] = 956] = "XBB";
	/**
	* XBC - --
	* @desc European Unit of Account 9
	* --
	*/
	Currency[Currency["XBC"] = 957] = "XBC";
	/**
	* XBD - --
	* @desc European Unit of Account 17
	* --
	*/
	Currency[Currency["XBD"] = 958] = "XBD";
	/**
	* XCD - --
	* @desc East Caribbean dollar
	* --
	*/
	Currency[Currency["XCD"] = 951] = "XCD";
	/**
	* XDR - --
	* @desc Special drawing rights (International Monetary Fund)
	* --
	*/
	Currency[Currency["XDR"] = 960] = "XDR";
	/**
	* XOF - --
	* @desc CFA franc BCEAO
	* --
	*/
	Currency[Currency["XOF"] = 952] = "XOF";
	/**
	* XPD - --
	* @desc Palladium
	* --
	*/
	Currency[Currency["XPD"] = 964] = "XPD";
	/**
	* XPF - --
	* @desc CFP franc
	* --
	*/
	Currency[Currency["XPF"] = 953] = "XPF";
	/**
	* XPT - --
	* @desc Platinum
	* --
	*/
	Currency[Currency["XPT"] = 962] = "XPT";
	/**
	* XTS - --
	* @desc Code reserved for testing
	* --
	*/
	Currency[Currency["XTS"] = 963] = "XTS";
	/**
	* XXX - --
	* @desc No currency
	* --
	*/
	Currency[Currency["XXX"] = 999] = "XXX";
	/**
	* YER - --
	* @desc Yemeni rial
	* --
	*/
	Currency[Currency["YER"] = 886] = "YER";
	/**
	* ZAR - --
	* @desc South African rand
	* --
	*/
	Currency[Currency["ZAR"] = 710] = "ZAR";
	/**
	* ZMK - --
	* @desc Zambian kwacha
	* --
	*/
	Currency[Currency["ZMK"] = 894] = "ZMK";
	/**
	* ZMW - --
	* @desc Zambian kwacha
	* --
	*/
	Currency[Currency["ZMW"] = 967] = "ZMW";
	/**
	* BTC - --
	* @desc Bitcoin
	* --
	*/
	Currency[Currency["BTC"] = 1001] = "BTC";
	/**
	* XUS - --
	* @desc USD Coin
	* --
	*/
	Currency[Currency["XUS"] = 1002] = "XUS";
	return Currency;
}({});
function createBaseMoney() {
	return {
		$type: "squareup.connect.v2.common.Money",
		amount: undefined,
		currency: undefined
	};
}
export const Money = {
	$type: "squareup.connect.v2.common.Money",
	encode(message, writer = new BinaryWriter()) {
		if (message.amount !== undefined) {
			writer.uint32(8).int64(message.amount);
		}
		if (message.currency !== undefined) {
			writer.uint32(16).int32(message.currency);
		}
		return writer;
	},
	decode(input, length) {
		const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
		const end = length === undefined ? reader.len : reader.pos + length;
		const message = createBaseMoney();
		while (reader.pos < end) {
			const tag = reader.uint32();
			switch (tag >>> 3) {
				case 1: {
					if (tag !== 8) {
						break;
					}
					message.amount = longToNumber(reader.int64());
					continue;
				}
				case 2: {
					if (tag !== 16) {
						break;
					}
					message.currency = reader.int32();
					continue;
				}
			}
			if ((tag & 7) === 4 || tag === 0) {
				break;
			}
			reader.skip(tag & 7);
		}
		return message;
	},
	create(base) {
		return Money.fromPartial(base ?? {});
	},
	fromPartial(object) {
		const message = createBaseMoney();
		message.amount = object.amount ?? undefined;
		message.currency = object.currency ?? undefined;
		return message;
	}
};
function longToNumber(int64) {
	const num = globalThis.Number(int64.toString());
	if (num > globalThis.Number.MAX_SAFE_INTEGER) {
		throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
	}
	if (num < globalThis.Number.MIN_SAFE_INTEGER) {
		throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
	}
	return num;
}
